import { connect } from 'react-redux';

import {
  getSubmittedQuestions,
  setQuestionNotification,
  setSwitchPfeSktAction,
} from '../actions/accountSettingsAction';
import { activateSubscription } from '../actions/manageSubscriptionActions';
import {
  breadcrumsAction,
  getAudioPlaylist,
  getAudioPlaylistsProgress,
  getContentByReference,
  getContentByWarfareQuals,
  getPdfByReference,
  getPostExamChecklistPdf,
  getQualById,
  setBackTo,
  setChapterId,
  setIsStudyFavoriteQuestion,
  setIsStudyingMyFavoriteQuestions,
  setIsStudyingMySubmittedQuestions,
  setIsStudyingSubmittedQuestions,
  updateAudioPlaylistProgress,
  updateDisabledChapter,
} from '../actions/studyMainActions';
import {
  favoriteListQuestionsSelector,
  getSwitchPfeSkt,
  getSwitchPfeSktMessage,
  getSwitchPfeSktWaiting,
  getUserSubscription,
} from '../components/AccountSettings/AccountSettingsSelectors';
import {
  getSubscriptionActivationMessage,
  getSubscriptionActivationSuccess,
  getSubscriptionActivationWaiting,
} from '../components/ManageSubscription/ManageSubscriptionSelectors';
import StudyMain from '../components/Study/StudyMain/studyMainView';
import {
  counterFavoriteSelector,
  counterMyFavoriteSelector,
  counterMySubmittedSelector,
  counterSubmittedSelector,
  getAudioPlaylistSelector,
  getAudioPlaylistsProgressFetchedSelector,
  getAudioPlaylistsProgressFetchingSelector,
  getAudioPlaylistsProgressSelector,
  getContentByReferenceFetchedSelector,
  getContentByReferenceFetchingSelector,
  getContentByRefSelector,
  getContentByWarfareQualsSelector,
  getPdfLink,
  getPostExamChecklistPdfLink,
  isLoadingPostExamChecklistPdf,
  isLoadingReferences,
  qualFromIdSelector,
  submittedListQuestionsSelector,
} from '../components/Study/studyMainSelectors';
import { getUser } from '../components/User/userSelectors';
import { verifyLoggedUser } from '../utils/verifyUserLogged';

const mapStateToProps = (state) => ({
  contentByRef: getContentByRefSelector(state),
  contentByReferenceFetched: getContentByReferenceFetchedSelector(state),
  contentByReferenceFetching: getContentByReferenceFetchingSelector(state),
  contentByWarfareQuals: getContentByWarfareQualsSelector(state),
  qual: qualFromIdSelector(state),
  user: getUser(state),
  userSubscription: getUserSubscription(state),
  pfeSktId: getSwitchPfeSkt(state),
  switchPfeSktMessage: getSwitchPfeSktMessage(state),
  switchPfeSktWaiting: getSwitchPfeSktWaiting(state),
  subscriptionActivationMessage: getSubscriptionActivationMessage(state),
  subscriptionActivationWaiting: getSubscriptionActivationWaiting(state),
  subscriptionActivationSucces: getSubscriptionActivationSuccess(state),
  pdfLink: getPdfLink(state),
  postExamChecklistPdfLink: getPostExamChecklistPdfLink(state),
  isLoadingPostExamChecklistPdf: isLoadingPostExamChecklistPdf(state),
  counterFavorite: counterFavoriteSelector(state),
  counterMyFavorite: counterMyFavoriteSelector(state),
  counterMySubmitted: counterMySubmittedSelector(state),
  counterSubmitted: counterSubmittedSelector(state),
  listFavoriteQuestions: favoriteListQuestionsSelector(state),
  listSubmittedQuestions: submittedListQuestionsSelector(state),
  audioPlaylist: getAudioPlaylistSelector(state),
  audioPlaylistsProgress: getAudioPlaylistsProgressSelector(state),
  audioPlaylistsProgressFetched:
    getAudioPlaylistsProgressFetchedSelector(state),
  audioPlaylistsProgressFetching:
    getAudioPlaylistsProgressFetchingSelector(state),
  isLoadingReferences: isLoadingReferences(state),
});

const mapDispatchToProps = (dispatch) => ({
  getByReference: (rate) => {
    dispatch(getContentByReference(rate));
  },
  getByWarfareQuals: (rate) => {
    dispatch(getContentByWarfareQuals(rate));
  },
  getQualFromId: (qual) => {
    dispatch(getQualById(qual));
  },
  verifyLoggedUser: () => {
    verifyLoggedUser();
  },
  setBackTo: (backTo) => {
    dispatch(setBackTo(backTo));
  },
  setChapterId: (chapterId) => {
    dispatch(setChapterId(chapterId));
  },
  setQuestionNotification: (id, idType) =>
    dispatch(setQuestionNotification(id, idType)),
  activateSubscription: () => {
    dispatch(activateSubscription());
  },
  setSwitchPfeSkt: (rate) => dispatch(setSwitchPfeSktAction(rate)),
  getPdfByReference: (payload) => dispatch(getPdfByReference(payload)),
  getPostExamChecklistPdf: () => dispatch(getPostExamChecklistPdf()),
  breadcrumsQualsAndCertsAction: (breadcrums) =>
    dispatch(breadcrumsAction(breadcrums)),
  getSubmittedQuestions: () => dispatch(getSubmittedQuestions()),
  setIsStudyingSubmittedQuestions: (status) =>
    dispatch(setIsStudyingSubmittedQuestions(status)),
  setIsStudyingFavoriteQuestions: (status) =>
    dispatch(setIsStudyFavoriteQuestion(status)),
  setIsStudyingMyFavoriteQuestions: (status) =>
    dispatch(setIsStudyingMyFavoriteQuestions(status)),
  setIsStudyingMySubmittedQuestions: (status) =>
    dispatch(setIsStudyingMySubmittedQuestions(status)),
  updateDisabledChapter: (chapterId, id) =>
    dispatch(updateDisabledChapter(chapterId, id)),
  getAudioPlaylist: (chapterId) => dispatch(getAudioPlaylist(chapterId)),
  getAudioPlaylistsProgress: (chapterIds) =>
    dispatch(getAudioPlaylistsProgress(chapterIds)),
  updateAudioPlaylistProgress: (
    chapterId,
    nextQuestionId,
    status,
    restartPlaylist,
  ) =>
    dispatch(
      updateAudioPlaylistProgress(
        chapterId,
        nextQuestionId,
        status,
        restartPlaylist,
      ),
    ),
});

const StudyMainContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(StudyMain);

export default StudyMainContainer;
